import { SelectionModel } from "@angular/cdk/collections";
import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter,
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ListColumn } from "src/app/models/list-columns.model";

@Component({
  selector: "app-hist-unit-table",
  templateUrl: "./special-table.component.html",
})
export class HistorialUnidadTableComponent implements OnInit {
  @Input() public showTitle: boolean = true;
  @Input() public title: string = "Registros";
  @Input() public keyactivos: string = "";
  @Input() public templateClassRow: (row) => string;

  @Output() onactions = new EventEmitter<{ action: string; row: any }>();
  @Input() public columns: ListColumn[] = [];
  @Input() public actions: any[] = [];
  @ViewChild(MatSort, { static: true }) public sort: MatSort;
  public dataSource: MatTableDataSource<any> | null;
  public pageSize: number = 10;

  @Input()
  get color(): string {
    return this._color;
  }
  set color(color: string) {
    this._color = color !== "light" && color !== "dark" ? "light" : color;
  }
  private _color = "light";

  @Input()
  get actionsType(): "menu" | "icons" {
    return this._actionsType;
  }
  set actionsType(color: "menu" | "icons") {
    this._actionsType = color;
  }
  private _actionsType: "menu" | "icons" = "menu";
  constructor() {}

  get visibleColumns() {
    return this.columns
      .filter((column) => column.visible)
      .map((column) => column.property);
  }

  ngOnInit(): void {
    if (this.templateClassRow == undefined) {
      this.templateClassRow = (row) => {
        return this.keyactivos != "" && !row[this.keyactivos]
          ? "bg-red-200"
          : "";
      };
    }
    this.dataSource = new MatTableDataSource();
    this.dataSource.data = [];
  }

  public ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  public onFilterChange(value: string) {
    if (!this.dataSource) return;
    this.dataSource.filter = value.trim().toLowerCase();
  }

  setData(rows: any[]) {
    this.dataSource.data = rows;
  }

  update(row) {
    this.onactions.emit({ action: "update", row: row });
  }
  delete(row) {
    this.onactions.emit({ action: "delete", row: row });
  }
  activate(row) {
    this.onactions.emit({ action: "activate", row: row });
  }

  sendAction(action, row) {
    this.onactions.emit({ action: action, row: row });
  }

  selection = new SelectionModel<any>(true, []);

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.data);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? "deselect" : "select"} all`;
    }
    return `${this.selection.isSelected(row) ? "deselect" : "select"} row ${
      row.position + 1
    }`;
  }

  public getLabelDown() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    if (numSelected == numRows || numSelected == 0)
      return "Obtener todos los registros";
    else return "Obtener registros selecionados " + numSelected + "/" + numRows;
  }
  public getSelectedDown() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    if (numSelected == numRows || numSelected == 0) return this.dataSource.data;
    else return this.selection.selected;
  }
}
